import { isTokenExpired, getRefreshToken, disconnect } from "@/js/http/auth";
export default {
  name: "TokenExpirationModal",
  created: function created() {
    if (this.IsTokenExpired) this.$EventBus.$emit("loading", false);
  },
  data: function data() {
    return {
      IsTokenExpired: isTokenExpired(getRefreshToken())
    };
  },
  methods: {
    agreeDialog: function agreeDialog() {
      disconnect(this);
    }
  }
};